import { PHASE_FIELDS } from 'lib/constants/healthcareProgram/paymentSetup';

import InNetwork from '../components/InNetwork/InNetwork';
import OutOfNetwork from '../components/OutOfNetwork/OutOfNetwork';
import SelfPay from '../components/SelfPay/SelfPay';

export const PRE_PHASE_TAB_OPTIONS = [
  {
    value: PHASE_FIELDS.IN_NETWORK,
    field: PHASE_FIELDS.IN_NETWORK,
    label: 'In-network',
    component: InNetwork
  },
  {
    value: PHASE_FIELDS.OUT_OF_NETWORK,
    field: PHASE_FIELDS.OUT_OF_NETWORK,
    label: 'Out-of-network',
    component: OutOfNetwork
  },
  {
    value: PHASE_FIELDS.SELF_PAY,
    field: PHASE_FIELDS.SELF_PAY,
    label: 'Self pay',
    component: SelfPay
  }
];
